module.exports = __webpack_public_path__ + "img/p1-pic@2x.ca7f628b.jpg";